module.exports = __webpack_public_path__ + "img/0Q3B3793_L_Foamcore.25013f1b.jpg";